"use client";

import {
  withDatasourceCheck,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import React from "react";
import * as Grid from "@repo/ui/grid";
import { useSmallViewport } from "@/components/viewport";
import { ComponentProps } from "../../types/component-props";
import MediaCta, { MediaCtaFieldsProps } from "./media-cta";
import classes from "./media-cta-grid.module.css";

export type MediaCtaGridProps = ComponentProps & {
  fields: {
    data: {
      datasource: {
        displayName: string;
        mediaCtas: { results: MediaCtaFieldsProps[] };
      };
    };
  };
};

const MediaCtaGrid = (props: MediaCtaGridProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const isMobile = useSmallViewport();

  const mediaCtasResult =
    props.fields?.data?.datasource?.mediaCtas?.results ?? [];

  if (!isEditing && (!mediaCtasResult || mediaCtasResult.length < 2)) {
    return <></>;
  }

  return (
    <>
      <Grid.Container
        columns={isMobile ? 1 : mediaCtasResult.length}
        className={classes.mediaCtaGridContainer}
      >
        {isEditing && (!mediaCtasResult || mediaCtasResult.length === 0) && (
          <p>Empty Media Grid Container Component</p>
        )}
        {mediaCtasResult.map((mediaCta, index) => (
          <MediaCta
            key={index}
            rendering={props.rendering}
            params={props.params}
            fields={mediaCta}
          />
        ))}
      </Grid.Container>
    </>
  );
};

export default withDatasourceCheck()<MediaCtaGridProps>(MediaCtaGrid);
